<his-dialog-header
	[showResetButton]="false"
	[showSaveButton]="false"
	[showBackButton]="showBackButton"
	[showSearchButton]="showSearchButton"
	[showCustomButton]="showEditButton && hasEditRights" [customButtonLabel]="'common.edit'"
	(customEvent)="edit()">
	<ng-container customButtons>
			<button *ngIf="comingFromSearchResult" class="backButtonResponsive" (click)="backToPersonSearchResult()"><span>{{'common.backToSearchResult' | hisUi}}</span></button>
		<ng-container *ngIf="isPersonCompletNameLoaded()">
			<his-display-webshare [btnTitle]="'cs.sys.webshare.person'" [title]="getFullPersonNameAndTitle()"
					[text]="getFullPersonNameAndTitle()" [url]="getUrl()">
			</his-display-webshare>
		</ng-container>
  	</ng-container>
</his-dialog-header>

<div *ngIf="!isEmpty(person)" class="layoutBlock detailpage">
	<div class="detailpageSideLeft">
		<div class="circleIconContainer">
			<div class="circle-icon">
				<div><img hisImage="user" class="inlineicon" [title]="'psv.Person' | hisUi"></div>
			</div>
		</div>
	</div>
	<div class="detailpageCenter tabMenueDetailpage">
		<psv-person-detail-view-vcard [person]="person"></psv-person-detail-view-vcard>
		<div class="details">
			<div class="detailPresentationList">

                <psv-collapsible-block-view *ngIf="showAboutMe || showResearchFields || showTeachingFields"
                    [headers]="blockViewHeader"
                    [hisObjects]="blockViewObjects"
                    [hisAttribute] ="'entrytext'"
                    expandToolTip="fs.res.finance.project.view.showFullLongtext"
                    collapseToolTip="fs.res.finance.project.view.showShortLongtext">
                </psv-collapsible-block-view>

                <div *ngIf="showAboutMe || showResearchFields || showTeachingFields" class="detailPresentationListItemBorder"></div>

				<div *ngIf="!isEmpty(person.extendedData) &&
							!isEmpty(person.extendedData['subjectAreas']) &&
							person.extendedData['subjectAreas'].length > 0"
						class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.SubjectAreaValue' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span *ngFor="let subjectArea of person.extendedData['subjectAreas']">
							<a [routerLink]="['/person/searchresult']" [queryParams]="{configFile: 'cs/psv/searchPersonsWithEmployments.xml', pageTitle: 'de.his.javang.suchen.personen.titel',
 								 tableTitle: 'de.his.javang.gefunden.personen', 'Employment.subjectAreas.id[]': subjectArea.id}" hisImage="tag_orange" class="singleLine transparent"
 								 title="{{ 'fs.res.common.subjectArea' | hisUi }}: {{ subjectArea.text }}">{{subjectArea.text}}</a>
						</span>
					</div>
				</div>

				<div *ngIf="!isEmpty(person.extendedData) &&
							!isEmpty(person.extendedData['researchAreasKdsf']) &&
							person.extendedData['researchAreasKdsf'].length > 0"
						class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.ResearchAreaKdsfValue' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span *ngFor="let researchAreaKdsf of person.extendedData['researchAreasKdsf']">
							<a *ngIf="researchAreaKdsf"
							    [routerLink]="['/person/searchresult']"
							    [queryParams]="getResearchAreaQueryParams(researchAreaKdsf, true)"
                                hisImage="tag_orange" class="singleLine transparent"
  							    title="{{ 'fs.res.common.researchAreasKdsf' | hisUi }}: {{ researchAreaKdsf.text }}">{{researchAreaKdsf.text}}</a>
						</span>
					</div>
				</div>
				<div *ngIf="!isEmpty(person.extendedData) &&
                            !isEmpty(person.extendedData['researchAreas']) &&
                            person.extendedData['researchAreas'].length > 0"
                        class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.ResearchAreaValue' | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent">
                        <span *ngFor="let researchArea of person.extendedData['researchAreas']">
                            <a [routerLink]="['/person/searchresult']"
                               [queryParams]="getResearchAreaQueryParams(researchArea, false)"
                               hisImage="tag_orange" class="singleLine transparent"
                               title="{{ 'fs.res.common.researcharea' | hisUi }}: {{ researchArea.text }}">{{researchArea.text}}</a>
                        </span>
                    </div>
                </div>
                <div class="layoutBlock detailPresentationListItem" *ngFor="let attribut of person.personAttributes | keyvalue:originalOrder">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{attribut.key}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{attribut.value}}</span></div>
                </div>
			</div>
		</div>

        <p-tabView *ngIf="items?.length >= 1" (click)="onBeforeSetActiveItem()" [(activeIndex)]="activeTabIndex">
            <ng-container *ngFor="let item of items; let i = index">
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <span hisImage="{{item.icon}}" class="inlineicon tabMenuLinkIcon"></span>
                        <div class="tabMenuLinkText">{{'cs.psv.person.detailview.tab.' + item.id | hisUi}}</div>
                    </ng-template>
                </p-tabPanel>
            </ng-container>
        </p-tabView>
	</div>
	<div class="detailpageSideRight">
		<!--Platzhalter für leere rechte Spalte-->
	</div>
</div>

<ng-container *ngIf="activeMenuItem?.tabIndex === 0 && items?.length > 1">
    <ng-container *ngIf="!isEmpty(person.extendedData) && !isEmpty(person.extendedData['listViews'])">
        <his-listview (btnMoreClicked)="setMenuItemById($event)" [customClickHandler]="true" [listviewKeys]="person.extendedData['listViews']" [listviewData]="person.extendedData"></his-listview>
    </ng-container>
</ng-container>

<ng-container *ngIf="search">
	<ng-container *ngFor="let item of items">
    	<psv-person-detail-view-search-result *ngIf="item.tabIndex === activeMenuItem?.tabIndex" [entityId]="activeMenuItem.id" [person]="person" [search]="search"></psv-person-detail-view-search-result>
	</ng-container>
</ng-container>
